package com.vamvisions.main.api.portfolio

import kotlinx.serialization.Serializable

/** The page section an experience belongs to, in display order. */
@Serializable
enum class ExperienceSectionDto { TIMELINE, LEARNING, EDUCATION }

/**
 * An experience entry of [section]. [highlights] are localized lines, possibly none: one line is a paragraph, several
 * are bullet points. [end] is null while it is ongoing. [url] is absolute, a site-relative path starting with `/`, or
 * null when the entry links nowhere. [skills] are its featured skills, in order.
 */
@Serializable
data class ExperienceDto(
    val slug: String,
    val section: ExperienceSectionDto,
    val name: String,
    val role: String,
    val highlights: List<String>,
    val start: PartialDate,
    val end: PartialDate?,
    val url: String?,
    val skills: List<SkillDto>,
)

@Serializable
data class ExperienceListResponseDto(
    val items: List<ExperienceDto>,
)
